// import React from "react";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";

export const CustomPaper = styled(Paper)(() => ({
  boxShadow: "rgb(0 0 0 / 5%) 0px 1px 3px -1px",
}));
